import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { addToHistory, setNavigate } from './navigationStore';

interface NavigationProviderProps {
  children: React.ReactNode;
}

export const NavigationProvider = ({
  children,
}: NavigationProviderProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  useEffect(() => {
    addToHistory(location.pathname + location.search, location.state);
  }, [location]);

  return <>{children}</>;
};
